import { Routes } from '@angular/router';
import { unsavedChangesGuard } from '@core/guards/unsaved-changes';
import { resultsHubActionsGuard, resultsHubAnalyticsGuard, resultsHubDefaultTabGuard } from './results-hub.guards';

/** The results list (`/:module/results/table`), and sending a message to the selected results. */
const resultsTableRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        title: 'str_common_results',
        loadComponent: () => import('@pages/results/results-page/results-page.component').then(c => c.ResultsPageComponent),
    },
    {
        path: 'messages/send',
        title: 'str_messagePage_title',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('@pages/messages/message-send-page/message-send-page.component').then(c => c.MessageSendPageComponent),
    },
];

/**
 * `/:module/results`: the Analytics and Actions tabs inside the hub shell, and `table` for the results list.
 * A bare `/:module/results` opens the first tab the user can see.
 */
export const resultsHubRoutes: Routes = [
    {
        path: 'results',
        children: [
            {
                path: '',
                pathMatch: 'full',
                canActivate: [resultsHubDefaultTabGuard],
                children: [],
            },
            {
                path: 'table',
                children: resultsTableRoutes,
            },
            {
                path: '',
                loadComponent: () => import('./results-hub-shell/results-hub-shell.component').then(c => c.ResultsHubShellComponent),
                children: [
                    {
                        path: 'analytics',
                        title: 'str_combinedResults_pageTitle',
                        canActivate: [resultsHubAnalyticsGuard],
                        data: { resultsHubMode: true, ownsHeader: true },
                        loadComponent: () => import('@pages/analytics/embeddable-page/embeddable-dashboards-page.component').then(c => c.EmbeddablePageComponent),
                    },
                    {
                        path: 'actions',
                        title: 'str_combinedResults_pageTitle',
                        canActivate: [resultsHubActionsGuard],
                        loadComponent: () => import('@pages/actions/action-point-overview-page/action-point-overview-page.component').then(c => c.ActionPointOverviewPageComponent),
                    },
                ],
            },
        ],
    },
];
